import React, { Component } from 'react'; 
import './HistorialMtoPrev.css'; 

import {getmtosprev,clearErrors,deleteMtoPreventivo,postMto} from '../../../redux/actions/dataactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaArrowLeft,FaFilePdf, FaTrash, FaCheckCircle } from "react-icons/fa";
import { Link } from 'react-router-dom';

import { Box, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, Typography, Grid } from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';

//getmtosprev
export class HistorialMtoPrev extends Component {

  constructor(){
    super();
    this.state={
        mtoid:'',
        errors:{},
        aprobado:{},
        open:false,
        opendelete:false
    };
    
};

       componentDidMount(){
       
        this.props.getmtosprev(this.props.equipoId);
       }

       static getDerivedStateFromProps(props, state) {
        const newState = {};
    
        if (props.UI.errors) {
            newState.errors = props.UI.errors;
        }
    
        if (props.UI.aprobado) {
           newState.aprobado = props.UI.aprobado;
        }
    
        return Object.keys(newState).length > 0 ? newState : null;
    }
       

       

                  
              handleOpenDelete=(rawdatamtoid)=>{
                this.setState({opendelete:true,mtoid:rawdatamtoid});
              
                };

          handleCloseDelete=()=>{
                  // this.props.clearErrors();
                    this.setState({opendelete:false,errors:{},aprobado:{}});
                    };

                    handleDelete=()=>{
                 
                        this.props.deleteMtoPreventivo(this.state.mtoid,this.props.equipoId);
                       
                                      
                  
                    }
          
      
    render() {

       const {mtospreventivos,loadingmto}= this.props.data; 
        const { UI:{loading}}=this.props;

         const columns=[
            {
              field:'acciones',
              headerName:'Acciones',
              width:150,
              sortable:false,
              filterable:false,
              renderCell: (params) => (
                <Box>
                  <Tooltip title="Ver Reporte PDF">
                    <IconButton size="small" component={Link} to={`/dashboard/perfilcliente/equipo/hojadevidapdf/reportepdfmto/${this.props.clienteId}/${this.props.equipoId}/${params.row.mtoid}/0`}>
                      <FaFilePdf color="#03178C" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Borrar Mantenimiento">
                    <IconButton size="small" onClick={() => this.handleOpenDelete(params.row.mtoid)}>
                      <FaTrash color="#03178C" />
                    </IconButton>
                  </Tooltip>
                </Box>
              )
            },
            { field:'fecha', headerName:'Fecha', width:150 },
            { field:'horainicio', headerName:'Hora Inicio', width:150 },
            { field:'horafinal', headerName:'Hora Final', width:150 },
            {
              field:'aprobado',
              headerName:'Aprobado',
              width:120,
              renderCell: (params) => {
                  if (params.row && Object.prototype.hasOwnProperty.call(params.row,'aprobado')) {
                      return params.row.aprobado === true ? 'Sí' : 'No';
                  }
                  return 'No';
              }
            },
          
        ];
     
        


        
     let mapeomtospreventivos=!loadingmto ?(
         <Box sx={{ width:'100%' }}>
            <Typography variant="h6" sx={{ fontSize: '16px', color: '#03178c', fontWeight: 600 }}>Mantenimientos Preventivos Realizados</Typography>
            <DataGrid
              rows={mtospreventivos}
              columns={columns}
              getRowId={(row) => row.mtoid}
              components={{ Toolbar: () => (
                <Box p={1}>
                  <GridToolbarQuickFilter placeholder="Buscar..." />
                </Box>
              ) }}
              disableSelectionOnClick
              sx={{ height: 500, width: '100%', mt: 2, '& .MuiDataGrid-columnHeaders': { backgroundColor: 'primary.main', color: 'white' } }}
            />
         </Box>


        ):(  <Box sx={{ display:'flex', justifyContent:'center', alignItems:'center' }}>
            <CircularProgress size={50} color="primary" className="login-progress" />
            </Box>);
            
        return (
              <div className="listamtoprog-container">
              
              <div className="listamtoprog-table">
              {mapeomtospreventivos}
              </div>

             
              <Dialog
             open={this.state.opendelete}
             onClose={this.handleCloseDelete}
             fullWidth
            maxWidth="sm"
            >

            {this.state.aprobado.mensaje ? (
              <DialogContent>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid item>
                    <FaTrash color="#ffffff" style={{ backgroundColor: '#03178C', borderRadius: '50%', padding: 8 }} />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography sx={{ fontSize: '16px', fontWeight: 600, textAlign: 'center', color: '#03178C' }}>
                      Reporte Borrado Exitosamente
                    </Typography>
                  </Grid>
                </Grid>
              </DialogContent>
                ) : (
              <DialogTitle>
                <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
                  ¿Estás seguro de borrar este Mantenimiento Preventivo?
                </Typography>
              </DialogTitle>
            )}

            <DialogActions sx={{ justifyContent: 'center' }}>
              <Tooltip title="Cerrar">
                <IconButton onClick={this.handleCloseDelete}>
                  <FaArrowLeft color="#D3D7DC" />
                </IconButton>
              </Tooltip>
              {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : (
                this.state.aprobado.mensaje ? (
                  <Tooltip title="Continuar">
                    <IconButton onClick={this.handleCloseDelete}>
                      <FaCheckCircle color="#f9044e" />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip title="Borrar Mantenimiento">
                    <IconButton onClick={this.handleDelete}>
                      <FaTrash color="#03178C" />
                    </IconButton>
                  </Tooltip>
                )
              )}

           </DialogActions>
            </Dialog>
        

  
            </div>
        )
    }
}



HistorialMtoPrev.propTypes = {
    
      getmtosprev: PropTypes.func.isRequired,
      data:PropTypes.object.isRequired,
      user:PropTypes.object.isRequired,
      clearErrors:PropTypes.func.isRequired,
      UI:PropTypes.object.isRequired,
      deleteMtoPreventivo:PropTypes.func.isRequired
    };
  
  const mapActionsToProps={getmtosprev,clearErrors,deleteMtoPreventivo,postMto};
  
  const mapStateToProps = (state)=>({
      data:state.data,
      user:state.user,
      UI:state.UI
  })
  
  
  
  export default connect(mapStateToProps,mapActionsToProps)(HistorialMtoPrev);
  
